import CLUBS_JSON from './clubsJsonConfig.json';
export default CLUBS_JSON;
